import { useSelector } from '@xstate/store-react';
import { store } from '../store';

export const useAppState = () => useSelector(store, (state) => state.context.app);
